module.exports = __webpack_public_path__ + "static/media/check-icon.50f83771.svg";